import {
    processGetManyFilter,
    processGetManyByReferenceFilter,
    processFilters,
    processAccountFilter, addSortToUrl, readJsonOrRefuse, refuseOnHttpError} from "./provider/defaults";
import {
    CreateParams,
    DataProvider,
    DeleteManyParams,
    DeleteParams,
    GetListParams,
    GetManyParams,
    GetManyReferenceParams,
    GetOneParams,
    UpdateManyParams,
    UpdateParams,
    CreateResult,
    GetListResult,
    GetManyReferenceResult,
    GetManyResult,
    GetOneResult,
    HttpError,
    UpdateManyResult,
    UpdateResult
} from "react-admin";
import { read_cookie, delete_cookie } from 'sfcookies';
import { hostUrl, UseUrlManagerCleanUrl, apiUrl } from "../components/utils/url-manager";
import { CompaniesHousePeople } from "../types/entities";

function cleanParams(contact: any[]): CompaniesHousePeople {
    return {
        id: contact['id'],
        name: contact['name'],
        role: contact['role'],
        activeDirector: contact['activeDirector'],
        companiesHouse: contact['companiesHouse'].replace('/hq_api/companies_houses/', ''),
        resigned: contact['resigned'],
        appointedOn: contact['appointed_on'],
    }
}

const adminCompaniesHousePeopleDataProvider: DataProvider = {

    getList: async (resource: string, params: GetListParams): Promise<GetListResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processAccountFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                if (data['@type'] === 'hydra:error') {
                    const error: HttpError = new HttpError(data['hydra:description'], null, null);
                    return Promise.reject(error);
                } else {
                    let responseData: { data: CompaniesHousePeople[], total: number } = {
                        data: [],
                        total: 0
                    };

                    if (Array.isArray(data['hydra:member'])) {
                        let contacts: any[] = data['hydra:member'];
                        let totalItems: number = data['hydra:totalItems'];

                        for(let i: number = 0; i < contacts.length; i++) {
                            let contact: any = contacts[i];
                            responseData.data.push(cleanParams(contact))
                        }
                        responseData.total = totalItems;
                    }
                    return responseData;
                }
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error)
            });
    },
    // get a single record by id
    getOne: async (resource: string, params: GetOneParams) : Promise<GetOneResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                let responseData: { data: CompaniesHousePeople|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data);
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // get a list of records based on an array of ids
    getMany: async (resource: string, params: GetManyParams) : Promise<GetManyResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        url = processGetManyFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                let responseData: { data: CompaniesHousePeople[], total: number } = {
                    data: [],
                    total: 0
                };

                if (Array.isArray(data['hydra:member'])) {
                    let contacts: any[] = data['hydra:member'];
                    for(let i: number = 0; i < contacts.length; i++) {
                        let contact: any[] = contacts[i];
                        responseData.data.push(cleanParams(contact));
                    }
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error)
            });
    },
    // get the records referenced to another record, e.g. comments for a post
    getManyReference: async (resource: string, params: GetManyReferenceParams) : Promise<GetManyReferenceResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processGetManyByReferenceFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {

                if (data['@type'] === 'hydra:error') {
                    const error: HttpError = new HttpError(data['hydra:description'], null, null);
                    return Promise.reject(error);
                } else {
                    let responseData: { data: CompaniesHousePeople[], total: number } = {
                        data: [],
                        total: 0
                    };

                    if (Array.isArray(data['hydra:member'])) {
                        let contacts: any[] = data['hydra:member'];
                        let totalItems: number = data['hydra:totalItems'];
                        //debugger;
                        for(let i: number = 0; i < contacts.length; i++) {
                            let contact: any[] = contacts[i];
                            responseData.data.push(cleanParams(contact));
                        }
                        responseData.total = totalItems;
                    }
                    return responseData;
                }
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // create a record
    create: async (resource: string, params: CreateParams) : Promise<CreateResult> => {
        let token: string = read_cookie('auth');
        params.data.companiesHouse = "/hq_api/companies_houses/" + params.data.companiesHouse;
        let url: string = apiUrl + resource;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                if (data['@type'] === 'hydra:error') {
                    const error: HttpError = new HttpError(data['hydra:description'], null, null);
                    return Promise.reject(error);
                } else {
                    let responseData: { data: CompaniesHousePeople|null } = {
                        data: null
                    };

                    if (data['id']) {
                        responseData.data = cleanParams(data);
                    }
                    return responseData;
                }
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });

    },
    // update a record based on a patch
    update: async (resource: string, params: UpdateParams) : Promise<UpdateResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.data.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'PATCH',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/merge-patch+json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                if (data['@type'] === 'hydra:error') {
                    const error: HttpError = new HttpError(data['hydra:description'], null, null);
                    return Promise.reject(error);
                } else {
                    let responseData : { data: CompaniesHousePeople|null } = {
                        data: null
                    };

                    if (data['id']) {
                        responseData.data = cleanParams(data);
                    }
                    return responseData;
                }
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // update a list of records based on an array of ids and a common patch
    updateMany: async (resource: string, params: UpdateManyParams) : Promise<UpdateManyResult> => {
        return Promise.reject();
    },
    // delete a record by id
    delete: async (resource: string, params: DeleteParams) : Promise<any> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return refuseOnHttpError(response)
                    .then((): { data: any } => ({ data: params }));
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // delete a list of records based on an array of ids
    deleteMany: async (resource: string, params: DeleteManyParams) : Promise<any> => {
        return Promise.reject();
    },
    getProfileData: (params) => {
        return Promise.resolve();
    }
}



export default adminCompaniesHousePeopleDataProvider;